import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const TemplateModern = ({ data }) => {
  if (!data) return null;
  const rawInvoice = data.invoice || data.Invoice;
  if (!rawInvoice) return null;

  // Normalize Invoice object to support both camelCase and PascalCase
  const invoice = {
    id: rawInvoice.id || rawInvoice.Id,
    clientId: rawInvoice.clientId || rawInvoice.ClientId,
    templateId: rawInvoice.templateId || rawInvoice.TemplateId,
    invoiceNo: rawInvoice.invoiceNo || rawInvoice.InvoiceNo,
    invoiceDate: rawInvoice.invoiceDate || rawInvoice.InvoiceDate,
    billerGSTIN: rawInvoice.billerGSTIN || rawInvoice.BillerGSTIN || '',
    billerAddress: rawInvoice.billerAddress || rawInvoice.BillerAddress || '',
    billerContact: rawInvoice.billerContact || rawInvoice.BillerContact || '',
    billToCompany: rawInvoice.billToCompany || rawInvoice.BillToCompany || '',
    billToName: rawInvoice.billToName || rawInvoice.BillToName || '',
    billToAddress: rawInvoice.billToAddress || rawInvoice.BillToAddress || '',
    billToGSTIN: rawInvoice.billToGSTIN || rawInvoice.BillToGSTIN || '',
    billToEmail: rawInvoice.billToEmail || rawInvoice.BillToEmail || '',
    subTotal: rawInvoice.subTotal || rawInvoice.SubTotal || 0,
    totalCGST: rawInvoice.totalCGST || rawInvoice.TotalCGST || rawInvoice.totalCgst || rawInvoice.TotalCgst || 0,
    totalSGST: rawInvoice.totalSGST || rawInvoice.TotalSGST || rawInvoice.totalSgst || rawInvoice.TotalSgst || 0,
    grandTotal: rawInvoice.grandTotal || rawInvoice.GrandTotal || 0,
    paymentStatus: rawInvoice.paymentStatus || rawInvoice.PaymentStatus || 'Unpaid',
    templateComponent: rawInvoice.templateComponent || rawInvoice.TemplateComponent || '',
    billerCompany: rawInvoice.billerCompany || rawInvoice.BillerCompany || 'Intechronix',
    billerLogoUrl: rawInvoice.billerLogoUrl || rawInvoice.BillerLogoUrl || ''
  };

  const rawItems = data.items || data.Items || [];
  const items = rawItems.map(item => ({
    description: item.description || item.Description || '',
    hsnSacCode: item.hsnSacCode || item.HsnSacCode || '',
    qty: item.qty || item.Qty || 0,
    netPrice: item.netPrice || item.NetPrice || 0,
    gstPercentage: item.gstPercentage || item.GstPercentage || 0,
    cgstAmount: item.cgstAmount || item.CgstAmount || 0,
    sgstAmount: item.sgstAmount || item.SgstAmount || 0,
    totalItemPrice: item.totalItemPrice || item.TotalItemPrice || 0
  }));

  const rawPayments = data.payments || data.Payments || [];
  const payments = rawPayments.map(p => ({
    transactionDesc: p.transactionDesc || p.TransactionDesc || '',
    transactionDate: p.transactionDate || p.TransactionDate || '',
    modeOfPayment: p.modeOfPayment || p.ModeOfPayment || '',
    transactionId: p.transactionId || p.TransactionId || '',
    amount: p.amount || p.Amount || 0
  }));

  const status = invoice.paymentStatus.toUpperCase();
  const statusColor = status === 'PAID' ? '#10B981' : '#EF4444';

  const seller = invoice.billerCompany;
  const invNo = invoice.invoiceNo;
  const billTo = invoice.billToCompany;
  const total = invoice.grandTotal.toFixed(2);
  const gst = invoice.billToGSTIN || 'N/A';
  const primaryColor = invoice.templateColor || '#4F46E5';

  const qrData = `SELLER: ${seller}\nINV NO: ${invNo}\nBILL TO: ${billTo}\nGSTIN: ${gst}\nTOTAL: ₹${total}\nSTATUS: ${status}`;

  return (
    <div className="invoice-preview-card" style={{ 
        position: 'relative', 
        overflow: 'hidden', 
        padding: '12mm', 
        width: '210mm', 
        height: '297mm', 
        margin: '0 auto', 
        boxSizing: 'border-box', 
        backgroundColor: '#fff', 
        fontSize: '11pt', 
        lineHeight: '1.3',
        color: '#1e293b'
    }}>
      {/* Watermark */}
      <div style={{ 
        position: 'absolute', 
        top: '35%', 
        left: '50%', 
        transform: 'translate(-50%, -50%) rotate(-25deg)', 
        fontSize: '8rem', 
        fontWeight: '900', 
        color: statusColor, 
        opacity: 0.3, 
        letterSpacing: '10px', 
        zIndex: 0, 
        pointerEvents: 'none', 
        userSelect: 'none' 
      }}>
        {status}
      </div>

      {/* Header: Shipper Details */}
      <div className="invoice-header" style={{ 
        position: 'relative', 
        zIndex: 1, 
        marginBottom: '1rem', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start', 
        borderBottom: '2px solid #f1f5f9', 
        paddingBottom: '1rem' 
      }}>
        <div>
          <img src={invoice.billerLogoUrl || invoice.BillerLogoUrl || "https://intechronix.com/images/logo.svg"} alt="Logo" style={{ height: '100px', marginBottom: '0rem' }} />
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#0f172a', marginBottom: '2px' }}>{seller}</div>
          <div style={{ whiteSpace: 'pre-line', color: '#64748b', fontSize: '10pt' }}>{invoice.billerAddress}</div>
          <div style={{ color: '#64748b', fontSize: '10pt' }}>Contact: {invoice.billerContact}</div>
          <div style={{ color: '#0f172a', fontWeight: '700', fontSize: '10pt', marginTop: '2px' }}>GSTIN: {invoice.billerGSTIN}</div>
        </div>
      </div>

      {/* Invoice Meta and QR */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', position: 'relative', zIndex: 1, alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: '1.3rem', fontWeight: '800', color: primaryColor, letterSpacing: '-0.5px' }}>INVOICE #{invNo}</div>
          <div style={{ marginTop: '4px', color: '#64748b', fontSize: '10.5pt' }}>Date: <span style={{ color: '#1e293b', fontWeight: '600' }}>{new Date(invoice.invoiceDate).toLocaleDateString()}</span></div>
        </div>
        <div className="qr-code-container" style={{ padding: '6px', border: '1px solid #e2e8f0', borderRadius: '8px', background: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          <QRCodeSVG value={qrData} size={85} />
        </div>
      </div>

      {/* Bill To */}
      <div style={{ position: 'relative', zIndex: 1, marginBottom: '1.2rem' }}>
        <div style={{ padding: '1rem', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: '#64748b', marginBottom: '6px', fontWeight: '800', letterSpacing: '1px' }}>Bill To</div>
          <div style={{ color: '#1e293b' }}>
            <div style={{ fontSize: '1.15rem', fontWeight: '800', marginBottom: '2px', color: '#0f172a' }}>{invoice.billToCompany}</div>
            {invoice.billToName && <div style={{ fontWeight: '600', color: '#334155' }}>Attn: {invoice.billToName}</div>}
            <div style={{ whiteSpace: 'pre-line', fontSize: '10.5pt', color: '#475569' }}>{invoice.billToAddress}</div>
            {invoice.billToGSTIN && <div style={{ fontWeight: '700', marginTop: '4px', color: '#0f172a' }}>GSTIN: {invoice.billToGSTIN}</div>}
          </div>
        </div>
      </div>

      {/* Items Table */}
      <div style={{ position: 'relative', zIndex: 1, minHeight: '300px' }}>
        <table className="invoice-table" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1.2rem' }}>
          <thead>
            <tr style={{ backgroundColor: primaryColor, color: '#ffffff' }}>
              <th style={{ padding: '8px 12px', textAlign: 'left', borderRadius: '6px 0 0 6px', fontSize: '10pt' }}>S.No</th>
              <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '10pt' }}>Description</th>
              <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '10pt' }}>HSN/SAC</th>
              <th style={{ padding: '8px 12px', textAlign: 'center', fontSize: '10pt' }}>Qty</th>
              <th style={{ padding: '8px 12px', textAlign: 'right', fontSize: '10pt' }}>Price</th>
              <th style={{ padding: '8px 12px', textAlign: 'center', fontSize: '10pt' }}>GST%</th>
              <th style={{ padding: '8px 12px', textAlign: 'right', borderRadius: '0 6px 6px 0', fontSize: '10pt' }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {items && items.map((item, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '10px 12px' }}>{i + 1}</td>
                <td style={{ padding: '10px 12px', fontWeight: '500' }}>{item.description}</td>
                <td style={{ padding: '10px 12px' }}>{item.hsnSacCode}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>{item.qty}</td>
                <td style={{ padding: '10px 12px', textAlign: 'right' }}>₹{item.netPrice.toFixed(2)}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>{item.gstPercentage}%</td>
                <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: '700', color: '#0f172a' }}>₹{item.totalItemPrice.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <div className="totals-container" style={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'flex-end', marginBottom: '1.2rem' }}>
        <div style={{ width: '280px', background: '#f8fafc', padding: '1rem', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0', fontSize: '10pt' }}>
            <span style={{ color: '#64748b' }}>Sub Total:</span>
            <span style={{ fontWeight: '600' }}>₹{(invoice.subTotal || 0).toFixed(2)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0', fontSize: '10pt' }}>
            <span style={{ color: '#64748b' }}>CGST:</span>
            <span>₹{(invoice.totalCGST || 0).toFixed(2)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0', fontSize: '10pt' }}>
            <span style={{ color: '#64748b' }}>SGST:</span>
            <span>₹{(invoice.totalSGST || 0).toFixed(2)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0 0', borderTop: '2px solid #e2e8f0', marginTop: '8px' }}>
            <span style={{ fontWeight: '800', fontSize: '1.1rem', color: '#0f172a' }}>Grand Total:</span>
            <span style={{ fontWeight: '800', fontSize: '1.10rem', color: primaryColor }}>₹{(invoice.grandTotal || 0).toFixed(2)}</span>
          </div>
        </div>
      </div>

      {/* T&C and Digital Signature Footer */}
      <div style={{ position: 'relative', zIndex: 1, marginTop: 'auto' }}>
        <div style={{ fontSize: '9pt', color: '#475569', borderTop: '1px solid #f1f5f9', paddingTop: '10px' }}>
          <div style={{ fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>Notes / Terms & Conditions</div>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <span>• Payment due within agreed time.</span>
            <span>• GST as applicable.</span>
            <span>• Subject to Gorakhpur jurisdiction.</span>
          </div>
        </div>
        
        <div style={{ marginTop: '12px', textAlign: 'center', fontSize: '8.5pt', color: '#94a3b8', fontStyle: 'italic', borderTop: '1px dashed #e2e8f0', paddingTop: '8px' }}>
          ** This is a computer-generated document and does not require a physical signature. **
        </div>
      </div>
    </div>
  );
};

export default TemplateModern;
